module.exports = __webpack_public_path__ + "img/paperwork_2.0ce8198.jpg";